export default {
  loginLogs: "LoginLogs",
};
